import type { InputMode, KeyBindings } from '../hooks/useMorseInput'

export interface AppSettings {
  mode: InputMode
  keyBindings: KeyBindings
  wpm: number
  frequency: number
  volume: number
  showHint: boolean
}

export const DEFAULT_SETTINGS: AppSettings = {
  mode: 'paddle',
  keyBindings: {
    dit: 'KeyF',
    dah: 'KeyJ',
    straight: 'Space',
  },
  wpm: 15,
  frequency: 600,
  volume: 0.35,
  showHint: true,
}

export const KEY_OPTIONS = [
  ['KeyF', 'F'],
  ['KeyJ', 'J'],
  ['KeyD', 'D'],
  ['KeyK', 'K'],
  ['KeyA', 'A'],
  ['KeyL', 'L'],
  ['Space', 'スペース'],
  ['ArrowLeft', '←'],
  ['ArrowRight', '→'],
  ['ShiftLeft', '左 Shift'],
  ['ShiftRight', '右 Shift'],
  ['ControlLeft', '左 Ctrl'],
  ['ControlRight', '右 Ctrl'],
] as const

export function keyCodeLabel(code: string): string {
  const option = KEY_OPTIONS.find(([value]) => value === code)
  if (option) return option[1]
  if (code.startsWith('Key')) return code.slice(3)
  if (code.startsWith('Digit')) return code.slice(5)
  return code.replace(/(Left|Right)$/, ' $1')
}

